import { Injectable } from '@angular/core';
import { List } from 'immutable';
import { Range } from '../../../search-data/sub-models/range.model';
import { ITokenValue } from './master-list-item.component';
import {
  IMasterListItemData,
  IMasterListItemDataValue,
} from './master-list-item.interface';

@Injectable()
export class MasterListItemBuilder {
  constructor() {}

  buildTokenizedValues(entityData: List<IMasterListItemData>) {
    return entityData.map((listItemData: IMasterListItemData) => {
      return List(listItemData.values).map(
        ({
          value,
          highlights,
          truncateThreshold,
        }: IMasterListItemDataValue) => {
          const val = value === null ? '' : value.toString();
          const valLength = val.length;
          const ranges: List<Range> = highlights ? highlights.ranges : List();
          const values: ITokenValue[] = [];

          values.push({
            value: ranges.isEmpty()
              ? val
              : val.substr(0, ranges.first().offset),
            highlighted: false,
            truncateThreshold,
          });

          ranges.forEach((range: Range, index: number) => {
            const offset = range.offset;
            const len = range.rangeLength;

            values.push({
              value: val.substr(offset, len),
              highlighted: true,
              truncateThreshold,
            });

            if (offset + len < valLength) {
              const nextRange = ranges.get(index + 1);

              values.push({
                value: val.substring(
                  offset + len,
                  nextRange ? nextRange.offset : valLength
                ),
                highlighted: false,
                truncateThreshold,
              });
            }
          });

          return List(values) as List<ITokenValue>;
        }
      ) as List<List<ITokenValue>>;
    }) as List<List<List<ITokenValue>>>;
  }
}
